import React from 'react'
import Navigation from '../../components/Navigations/Navigation';
import Footer from '../../components/Footer/Footer';
import Services from '../../components/Services/Services';
import Slider from '../../components/ServiceSlider/ServiceSlider';


const ServicesPage = () => {
  return (
    <div>
      <div>
        <Navigation />
      </div>
      <div>
        <Slider />
      </div>
      <div>
        <Services />
      </div>
      <div>
        {/* <Footer /> */}
      </div>
    </div>
  )
}

export default ServicesPage
